
export default  { 
  namespaced:true,
  state : { 
    overAll:{},
    profit:[]
  },
  mutations : { 
    MUTATION_OVERALL (state,data) {
      state.overAll = data  
    },
    MUTATION_PROFIT (state,data) { 
      state.profit = data
    }, 
  },
  getters : {
    GETTERS_OVERALL : state=>state.overAll, 
    GETTERS_PROFIT : state=>state.profit, 
  }
}